import moment from 'moment'
moment.locale('pt-br');

class DateHelper {
    /**
     * Parse uma string de data no formato YYYY-MM-DD para Date local (sem timezone)
     * @param {string|Date} dateString - String de data ou objeto Date
     * @returns {Date|null} Objeto Date no timezone local ou null se inválido
     */
    static parse(dateString) {
        if (!dateString) return null;
        
        // Se já for um objeto Date, retorna como está
        if (dateString instanceof Date) {
            return dateString;
        }
        
        // Parse da string no formato YYYY-MM-DD sem timezone
        const parts = dateString.split('T')[0].split('-');
        if (parts.length === 3) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // Mês é 0-indexed
            const day = parseInt(parts[2], 10);
            return new Date(year, month, day);
        }
        
        // Fallback para o comportamento padrão
        return new Date(dateString);
    }

    /**
     * Formata uma data para o formato brasileiro DD/MM/YYYY
     * @param {string|Date} date - String de data ou objeto Date
     * @returns {string} Data formatada ou '-' se inválida
     */
    static format(date) {
        if (!date) return '-';
        
        const parsed = date instanceof Date ? date : this.parse(date);
        return parsed ? parsed.toLocaleDateString('pt-BR') : '-';
    }

    /**
     * Exibe data em pt-BR: campos só-data (YYYY-MM-DD) como dia civil local;
     * valores com hora (ISO) usam o instante no fuso local.
     */
    static formatLocalDate(value) {
        if (!value) {
            return '-';
        }
        const s = String(value).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            return this.format(s);
        }
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) {
            return '-';
        }
        return d.toLocaleDateString('pt-BR');
    }
}

// Exporta moment como default para manter compatibilidade
export default moment;

// Exporta DateHelper como named export
export { DateHelper as Date };